import gql from 'graphql-tag';
import { ProductPriceOverrides, VariationPriceOverrides } from './Product';

//for some reason, it doesn't like nesting this inside the Invoices collection. nasty
export const Invoice = gql`
    ${ProductPriceOverrides}
    ${VariationPriceOverrides}
    fragment InvoiceObject on Invoice {
        ID
        Created
        LegacyID
        LegacyKey
        XeroID
        XeroStatus
        XeroReference
        Printed
        InvoiceDate
        InvoicePaid
        GstAmount
        Total
        InvoiceDueDate
        InvoiceTypeCode
        OriginatingOffice
        InvoiceStatus
        InvoiceSent
        InvoiceSentDatetime
        Archived
        IsPurchase # true for bills
        Funeral {
            ID
            LegacyKey
        }
        InvoiceItems {
            ID
            Sort
            Quantity
            ItemCode
            Price
            HasGST
            Prepaid
            Title
            XeroAccount
            GstAmount
            LineAmount
            Product {
                ID
                InternalItemID
                Title
                GST
                BasePrice
                ITC
                BaseWorth
                ...ProductPriceOverrides
            }
            Variation {
                ID
                InternalItemID
                ShortDescription
                GST
                Price
                ITC
                Worth
                Product {
                    ID
                    Title
                }
                ...VariationPriceOverrides
            }
        }
        SalesRegisterTransactions {
            ID
            LegacyKey
            TransType
            Nett
            Gst
            TransDate
            BankTransNo
            XeroReference
        }
        Customer {
            ID
            CustomerName
            FirstName #only new records
            MiddleName #only new records
            Surname #only new records
            Contact #this is used for companies.. a contact at a company
            AddressLine1
            AddressLine2
            Suburb
            Postcode
            State
            Country
            Phones {
                ID
                Number
                Type
                Comment
                Sort
            }
            RelationToDeceased
            Email
            BillingId
            BillingSource
        }
        CreatedBy {
            ID
            FirstName
            Surname
            Email
        }
    }
`;

export default gql`
    fragment Invoice on Funeral {
        Invoices {
            ID
            Created
            LegacyID
            LegacyKey
            XeroID
            XeroStatus
            XeroReference
            Printed
            InvoiceDate
            InvoicePaid
            GstAmount
            Total
            InvoiceDueDate
            InvoiceTypeCode
            OriginatingOffice
            InvoiceStatus
            InvoiceSent
            InvoiceSentDatetime
            Archived
            IsPurchase
            Funeral {
                ID
                LegacyKey
            }
            InvoiceItems {
                ID
                Sort
                Quantity
                ItemCode
                Price
                HasGST
                Prepaid
                Title
                XeroAccount
                GstAmount
                LineAmount
                Product {
                    ID
                    InternalItemID
                    Title
                    GST
                    BasePrice
                    ITC
                    BaseWorth
                }
                Variation {
                    ID
                    InternalItemID
                    ShortDescription
                    GST
                    Price
                    ITC
                    Worth
                    Product {
                        ID
                        Title
                    }
                }
            }
            SalesRegisterTransactions {
                ID
                LegacyKey
                TransType
                Nett
                Gst
                TransDate
                BankTransNo
                XeroReference
            }
            Customer {
                ID
                CustomerName
                FirstName #only new records
                MiddleName #only new records
                Surname #only new records
                Contact #this is used for companies.. a contact at a company
                AddressLine1
                AddressLine2
                Suburb
                Postcode
                State
                Country
                Phones {
                    ID
                    Number
                    Type
                    Comment
                    Sort
                }
                RelationToDeceased
                Email
                BillingId
                BillingSource
            }
            CreatedBy {
                ID
                FirstName
                Surname
                Email
            }
        }
    }
`;
